
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  width:100%;
}

.hidden{
  display:none;
}

button {
  display:flex;
  width:100%;
  align-items:center;
  justify-content:space-between;
  border-width:0px;
  padding-left:0px;
  padding-right:0px;
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
  font-weight:var(--fw-bold);
  line-height:2;
  color:var(--bh-brand-primary-default);
  color:var(--bh-neutral-black);
  transition-property:all;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
}

button:hover {
  padding-right:0.5rem;
  color:var(--bh-brand-primary-dark);
}

button{
  background-color:transparent;
}

button[aria-expanded='true'] {
  margin-bottom:1.25rem;
}

button[aria-expanded='true']{
    color:var(--bh-brand-primary-default);
  }

button:hover .doner-kebab,
  button:hover .menu-icon{
    color:var(--bh-brand-primary-dark);
  }

.menu-icon,
.close-icon{
  color:var(--bh-brand-primary-default);
}

.close-icon {
  margin-left:0.375rem;
  margin-right:0.375rem;
}

.separator {
  margin-bottom:1.75rem;
  border-top-width:0px;
  border-bottom-width:2px;
  border-style:solid;
  border-color:var(--bh-brand-primary-lighter);
}
`;